import React, { useEffect, useRef, useState } from "react";
import {
  View,
  Button,
  StyleSheet,
  Text,
  TouchableOpacity,
  Image,
  FlatList,
  Dimensions,
} from "react-native";
import { Avatar } from "react-native-elements";

import { commonStyles } from "../styles";
import heroList from "../static/heros.json";
import { HeroPanel } from "../components/HeroPanel";
import { SafeAreaView } from "react-native-safe-area-context";
type Hero = {
  id: string;
};

type ResultsScreenProps = {
  onClear: () => void;
  heros: Hero[];
  counters: any[];
};

const ResultsScreen = ({ onClear, heros, counters }: ResultsScreenProps) => {
  const [expandedItem, setExpandedItem] = useState<string | null>(null);

  const toggleExpand = (id: string) => {
    setExpandedItem(expandedItem === id ? null : id);
  };

  // Render each item
  const renderHero = ({ index, item }: any) => {
    return (
      <View style={styles.detectedItem} key={item.id}>
        <HeroPanel
          id={item.id}
          showName={true}
          size={50}
          nameBottom
          nameSize={8}
        />
      </View>
    );
  };

  const renderCounter = ({ index, item }: any) => {
    console.log("rendering counter", item);
    const isExpanded = item.hero === expandedItem;

    const counters = [...new Set(item.good.map((r: any) => r.target))];
    const nonCounters = [...new Set(item.bad.map((r: any) => r.target))];

    return (
      <View style={styles.counterItemContainer} key={"counter" + index}>
        <TouchableOpacity
          onPress={() => toggleExpand(item.hero)}
          style={styles.counterItemHeader}
        >
          <HeroPanel id={item.hero} />
          <View style={{ flexDirection: "row", width: 50 }}>
            {counters.map((c: any) => {
              return (
                <HeroPanel size={20} green={true} showName={false} id={c} />
              );
            })}
          </View>
          <View style={{}}>
            {nonCounters.map((c: any) => {
              return <HeroPanel size={20} red showName={false} id={c} />;
            })}
          </View>
          {/* <Text style={styles.score}>{item.score}</Text> */}
        </TouchableOpacity>
        {isExpanded && (
          <View style={styles.expandedContent}>
            {item.good.length > 0 ? (
              <View style={styles.detailSection}>
                <View style={styles.sectionHeader}>
                  <Text style={styles.headerPros}>Pros</Text>
                  {counters.map((c: any) => {
                    return (
                      <HeroPanel
                        key={`counter-expand-${index}${c}`}
                        size={40}
                        green={true}
                        showName={true}
                        nameSize={7}
                        nameBottom={true}
                        nameMaxWidth={30}
                        id={c}
                      />
                    );
                  })}
                </View>
                <View style={styles.bulletList}>
                  {item.good.map((item: any, index: number) => (
                    <Text key={`good_${index}`} style={styles.bulletPoint}>
                      • {item.description}
                    </Text>
                  ))}
                </View>
              </View>
            ) : null}
            {item.bad.length > 0 ? (
              <View style={styles.detailSection}>
                <View style={styles.sectionHeader}>
                  <Text style={styles.headerCons}>Cons</Text>
                  {nonCounters.map((c: any) => {
                    return (
                      <HeroPanel
                        key={`counter-expand-${index}${c}`}
                        size={40}
                        green={true}
                        showName={true}
                        nameSize={7}
                        nameBottom={true}
                        nameMaxWidth={30}
                        id={c}
                      />
                    );
                  })}
                </View>
                <View style={styles.bulletList}>
                  {item.bad.map((item: any, index: number) => (
                    <Text key={`bad_${index}`} style={styles.bulletPoint}>
                      • {item.description}
                    </Text>
                  ))}
                </View>
              </View>
            ) : null}
          </View>
        )}
      </View>
    );
  };

  const detectedContent = (
    <View style={styles.detected}>
      <Text style={styles.header}>Enemy Team</Text>
      <FlatList data={heros} renderItem={renderHero} horizontal />
    </View>
  );

  const countersContent = (
    <View style={styles.container}>
      <Text style={styles.header}>Counters</Text>
      <FlatList data={counters} renderItem={renderCounter} />
    </View>
  );

  return (
    <SafeAreaView style={styles.container}>
      {/* <Text style={commonStyles.infoBox}>
        {heros.length > 0 ? "Heros Found!" : "No Heros Found... Try again"}
      </Text> */}
      {detectedContent}
      {countersContent}
      <View
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <TouchableOpacity onPress={onClear} style={commonStyles.actionButton}>
          <Text style={commonStyles.actionButtonText}>Reset</Text>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: "space-evenly",
    padding: 10,
    flex: 1,
    height: "100%",
    backgroundColor: "#fff",
    // borderWidth: 3,
    // borderColor: 'green'
  },
  score: {
    fontFamily: "NinjaTurtles",
    color: "green",
  },
  header: {
    fontFamily: "NinjaTurtles",
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 4,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
  },
  sectionHeader: {
    display: "flex",
    flexDirection: "row",
    borderWidth: 0,
    borderBottomWidth: 1,
    borderColor: "#ccc",
    alignItems: "center",
    padding: 10,
  },

  detected: {
    backgroundColor: "white",
    height: 100,
    // borderWidth: 1,
  },
  detectedItem: {
    width: 65,

    alignItems: "center",
    justifyContent: "center",
  },

  //   counterItemHeader: {
  //     padding: 20,
  //   },

  counterItemContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    backgroundColor: "#fff",
    paddingVertical: 20,
    marginVertical: 8,
    marginHorizontal: 0,
    borderRadius: 5,
    // borderColor: 'red',
    // borderWidth:1,
    elevation: 3, // For Android shadow
    shadowColor: "#000", // For iOS shadow
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
  },

  counterItemHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#fff",
    // paddingVertical: 20,
    marginVertical: 8,
    marginHorizontal: 0,
    borderRadius: 5,
    // borderColor: 'red',
    // borderWidth:1,
    // elevation: 3, // For Android shadow
    // shadowColor: "#000", // For iOS shadow
    // shadowOffset: { width: 0, height: 2 },
    // shadowOpacity: 0.2,
    // shadowRadius: 2,
  },

  image: {
    width: 50,
    height: 50,
  },
  expandedContent: {
    justifyContent: "flex-start",
    // borderWidth: 1,
    marginTop: 10,
  },
  detailSection: {
    borderWidth: 0,


    marginTop: 10,
  },
  bulletList: {
    //borderWidth: 1,

    marginTop: 10,
  },

  headerPros: {
    fontSize: 16,
    fontWeight: "600",
    marginBottom: 5,
    color: "green",
    fontFamily: "NinjaTurtles",
  },
  headerCons: {
    fontSize: 16,
    fontWeight: "600",
    marginBottom: 5,
    color: "#ff0000",
    fontFamily: "NinjaTurtles",
  },
  bulletPoint: {
    fontSize: 10,
    marginTop: 2,
    fontWeight: 700,
  },
});

export default ResultsScreen;
